/* bhby-byob.js — inject a 2-3 word benefit line into each Simple Bundles BYOB
   product card (the app card has no benefit field). Matches our custom picker.
   Runs on BYOB pages only (no-op if no .byob-bundle__product-card present). */
(function () {
  var BEN = [
    [/magnesium/i, 'Calm & sleep'],
    [/ashwagandha/i, 'Stress & balance'],
    [/biotin/i, 'Hair & nails'],
    [/turmeric/i, 'Joint comfort'],
    [/beetroot/i, 'Energy & circulation'],
    [/creatine/i, 'Strength & recovery'],
    [/focus/i, 'Memory & focus'],
    [/lion|mane|mushroom/i, 'Brain & immunity'],
    [/vitamin c|vit c|zinc/i, 'Immune defense'],
    [/collagen/i, 'Skin & joints'],
    [/melatonin/i, 'Sleep support'],
    [/moringa/i, 'Daily greens'],
    [/hair,? ?skin|\bhsn\b/i, 'Beauty blend']
  ];
  function benefitFor(t) {
    for (var i = 0; i < BEN.length; i++) { if (BEN[i][0].test(t)) return BEN[i][1]; }
    return '';
  }
  function decorate() {
    var cards = document.querySelectorAll('.byob-bundle__product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.bhby-byob-benefit')) continue;
      var titleEl = card.querySelector('.byob-bundle__product-card-title-text, .byob-bundle__product-card-title');
      if (!titleEl) continue;
      var b = benefitFor(titleEl.textContent || '');
      if (!b) continue;
      var el = document.createElement('div');
      el.className = 'bhby-byob-benefit';
      el.textContent = b;
      titleEl.insertAdjacentElement('afterend', el);
    }
  }
  function init() {
    decorate();
    var grid = document.querySelector('.byob-bundle__product-grid') || document.querySelector('.byob-bundle__root');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () { decorate(); }).observe(grid, { childList: true, subtree: true });
    }
    // retry for late hydration
    var n = 0, iv = setInterval(function () { decorate(); if (++n > 10) clearInterval(iv); }, 500);
  }
  if (document.readyState !== 'loading') setTimeout(init, 600);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 600); });
})();

/* ---- prevent the same SKU being added more than once (app has no setting) ----
   The app exposes no reliable per-card "selected" flag and the cart items are
   opaque, so we: (1) block re-adding a card that's already in the box (capture
   phase, before the app's modal opens), (2) cap the add-modal quantity at 1,
   (3) detect a successful add by a rise in the cart Subtotal and mark the
   last-clicked card "In your box". On removal (subtotal drops) we re-open all
   cards (the app keeps the real selections; user re-picks if needed). */
(function () {
  /* no early DOM guard — the BYOB grid hydrates after this script loads, so we
     attach a document-level listener + interval that act only when cards exist. */
  var selected = {};     // title -> card element
  var lastClicked = null;
  var lastSub = -1;

  function titleOf(card) {
    var t = card.querySelector('.byob-bundle__product-card-title-text, .byob-bundle__product-card-title');
    return t ? t.textContent.trim() : '';
  }
  function setLabel(card, txt) {
    var l = card.querySelector('.byob-cta--add .byob-cta__label') || card.querySelector('.byob-cta--add');
    if (l) l.textContent = txt;
  }
  function mark(card) {
    if (!card) return;
    card.classList.add('bhby-byob-in-box');
    var b = card.querySelector('.byob-cta--add'); if (b) b.setAttribute('aria-disabled', 'true');
    setLabel(card, 'In your box');
  }
  function unmark(card) {
    card.classList.remove('bhby-byob-in-box');
    var b = card.querySelector('.byob-cta--add'); if (b) b.removeAttribute('aria-disabled');
    setLabel(card, 'Add');
  }

  // (1) block re-add at capture phase (before the app's modal opens)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.byob-cta--add');
    if (!btn) return;
    if (btn.closest('.byob-options-modal')) return;        // let the modal's own confirm through
    var card = btn.closest('.byob-bundle__product-card');
    if (!card) return;
    if (card.classList.contains('bhby-byob-in-box')) {
      e.preventDefault(); e.stopImmediatePropagation();
      setLabel(card, 'Already added');
      setTimeout(function () { setLabel(card, 'In your box'); }, 1200);
      return;
    }
    lastClicked = card;
  }, true);

  // (2) cap add-modal quantity at 1  +  (3) watch cart subtotal
  function subtotal() {
    var c = document.querySelector('.byob-bundle__cart'); if (!c) return lastSub;
    var m = (c.innerText || '').match(/Subtotal\s*\$([\d.,]+)/i);
    return m ? parseFloat(m[1].replace(/,/g, '')) : lastSub;
  }
  setInterval(function () {
    // cap modal
    var m = document.querySelector('.byob-options-modal');
    if (m) {
      var input = m.querySelector('input[type="number"], input');
      if (input) { input.max = '1'; if (parseInt(input.value, 10) > 1) input.value = '1'; }
      var btns = m.querySelectorAll('button');
      for (var i = 0; i < btns.length; i++) {
        var t = (btns[i].textContent || '').trim();
        if (t === '+' || /increase/i.test(btns[i].getAttribute('aria-label') || '')) {
          btns[i].disabled = true; btns[i].style.opacity = '.35'; btns[i].style.pointerEvents = 'none';
        }
      }
    }
    // watch subtotal
    var s = subtotal();
    if (lastSub < 0) { lastSub = s; return; }
    if (s > lastSub && lastClicked) { mark(lastClicked); selected[titleOf(lastClicked)] = lastClicked; lastClicked = null; }
    else if (s < lastSub) { Object.keys(selected).forEach(function (k) { unmark(selected[k]); }); selected = {}; }
    lastSub = s;
  }, 400);
})();

/* "Back to picker" — inject a button into the bundle mini-cart that jumps back
   up to the product grid (most useful on mobile where the cart is a sticky bar). */
(function () {
  function inject() {
    var cart = document.querySelector('.byob-mini-cart');
    if (!cart || cart.querySelector('.bhby-back-to-picker')) return;
    var checkout = cart.querySelector('.byob-mini-cart__checkout');
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'bhby-back-to-picker';
    b.setAttribute('aria-label', 'Back to product picker');
    b.innerHTML = '<span aria-hidden="true">↑</span> Back to picker';
    b.addEventListener('click', function () {
      var g = document.querySelector('.byob-bundle__picker') ||
              document.querySelector('.byob-bundle__product-grid') ||
              document.querySelector('.byob-bundle__root');
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (checkout && checkout.parentElement) checkout.parentElement.insertBefore(b, checkout);
    else cart.appendChild(b);
  }
  setInterval(inject, 700);
})();

/* "Save up to $X" banner — max possible savings = the N most expensive eligible
   products (N = active pack item-count) x that pack's discount-percent. Reads the
   live byob-pack attributes so it tracks whatever % is set in the app, and updates
   when the shopper switches 3<->6 pack. */
(function () {
  function priciestSum(n) {
    var prices = [].slice.call(document.querySelectorAll('.byob-bundle__product-card-price'))
      .map(function (e) { var m = (e.textContent || '').match(/([\d]+(?:\.[\d]+)?)/); return m ? parseFloat(m[1]) : 0; })
      .filter(function (v) { return v > 0; })
      .sort(function (a, b) { return b - a; });
    var s = 0; for (var i = 0; i < n && i < prices.length; i++) s += prices[i];
    return s;
  }
  function update() {
    var pack = document.querySelector('byob-pack[active]') || document.querySelector('byob-pack');
    if (!pack) return;
    var n = parseInt(pack.getAttribute('item-count') || '3', 10);
    var d = parseFloat(pack.getAttribute('discount-percent') || '0');
    if (!d) return;
    var el = document.querySelector('.bhby-byob-savings');
    if (!el) {
      el = document.createElement('div');
      el.className = 'bhby-byob-savings';
      var host = document.querySelector('.byob-bundle__products') || document.querySelector('.byob-bundle__picker');
      if (host) host.insertBefore(el, host.firstChild); else return;
    }
    el.innerHTML =
      '<span class="bhby-byob-savings__how">Pick any ' + n + ' · mix &amp; match your routine · free shipping</span>' +
      '<span class="bhby-byob-savings__save">Save <b>' + d + '%</b> on your ' + n + '-pack</span>';
  }
  // pack-pill discount callout: add "Save X%" to each 3-Pack / 6-Pack pill so the
  // bigger pack visibly rewards more (incentive to click 6-Pack).
  function decoratePacks() {
    var packs = document.querySelectorAll('byob-pack[discount-percent]');
    for (var i = 0; i < packs.length; i++) {
      var d = parseFloat(packs[i].getAttribute('discount-percent') || '0');
      if (!d) continue;
      var opt = packs[i].querySelector('.byob-option');
      if (!opt) continue;
      var b = opt.querySelector('.bhby-pack-save');
      if (!b) { b = document.createElement('span'); b.className = 'bhby-pack-save'; opt.appendChild(b); }
      b.textContent = 'Save ' + d + '%';
    }
  }
  setInterval(function () { update(); decoratePacks(); }, 700);
})();

/* Hard-block the image/title click that opens the options modal once a product
   is in the box (capture phase, before the app's handler). The CSS pointer-events
   handles the cursor; this guarantees the modal can't reopen. Auto-restores when
   the card loses .bhby-byob-in-box (removed from pack). */
document.addEventListener('click', function (e) {
  var t = e.target;
  if (!t || !t.closest) return;
  if (!t.closest('.bhby-byob-in-box')) return;
  if (t.closest('.byob-bundle__product-card-media--clickable, .byob-bundle__product-card-title--clickable, .byob-bundle__product-card-title-text')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
}, true);
